import { Router } from "next/router";

export function parseUrl(query: Router["query"]) {
  const { step } = query;

  const [stepName, animalId] = Array.isArray(step) ? step : [step];

  return { stepName, animalId };
}
